import { LOCALSTORAGE_DISCOUNT_CODE } from '@constants/localStorage';
import { useSessionStorage } from '@monofront/business/hooks';

export const useDiscountCode = () => {
  return useSessionStorage<string | null>(LOCALSTORAGE_DISCOUNT_CODE, null);
};
